import { FC, ReactNode } from 'react';
import { SvgIcon } from '@mui/material';

import LeftChevronIcon from '../../icons/ChevronLeft.svg';

import { AnimatedSlot } from './ui/AnimatedSlot/AnimatedSlot';
import {
	AddressBlockSection,
	AddressInputWrapper,
	BackButtonWrapper,
	BackgroundLayer,
	BottomSlotsContainer,
	RootContainer,
	StyledBackButton,
} from './styled';

export interface ISearchFlowLayoutProps {
	/** Back button handler */
	onBack?: () => void;
	/** Address input slot (e.g., rendered MplRouteInput) */
	addressInput?: ReactNode;
	/** Bottom Sheet slot (e.g., rendered <SearchFlowBottomSheet/>) */
	bottomSheet?: ReactNode;
	/** Future map background */
	mapBackground?: ReactNode;
	/** Action button at the bottom of the screen (animates first) */
	bottomAction?: ReactNode;
	/** Info element above the action button (animates second, with stagger delay) */
	bottomInfo?: ReactNode;
}

export const SearchFlowLayout: FC<ISearchFlowLayoutProps> = ({
	onBack,
	addressInput,
	mapBackground,
	bottomSheet,
	bottomAction,
	bottomInfo,
}) => {
	return (
		<RootContainer>
			<BackgroundLayer>{mapBackground}</BackgroundLayer>

			<AddressBlockSection>
				{onBack && (
					<BackButtonWrapper>
						<AnimatedSlot slotOffset={100} direction="right">
							<StyledBackButton
								onClick={onBack}
								data-testid="searchFlowLayout-back-button"
							>
								<SvgIcon component={LeftChevronIcon} />
							</StyledBackButton>
						</AnimatedSlot>
					</BackButtonWrapper>
				)}

				<AddressInputWrapper>
					<AnimatedSlot slotOffset={200} direction="left">
						{addressInput}
					</AnimatedSlot>
				</AddressInputWrapper>
			</AddressBlockSection>

			{bottomSheet}

			<BottomSlotsContainer>
				{/*IMPORTANT: Keep <AnimatedSlot> mounted in order the unmount animation to work properly */}
				<AnimatedSlot>{bottomInfo}</AnimatedSlot>
				<AnimatedSlot>{bottomAction}</AnimatedSlot>
			</BottomSlotsContainer>
		</RootContainer>
	);
};
